import type { ComponentProps } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import * as React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import moment from 'moment';

import { t } from 'Src/i18n';
import { momentFromApiDate } from 'Utils/date/apiDate';

import { InfoBanner } from 'Components/widgets/info-banner/InfoBanner';

// eslint-disable-next-line clubmed/no-fake-component
export const renderInfoBanner = ({
  infoBannerData,
  departureDate,
  arrivalDate,
  currentStep,
  containerClassName,
  theme,
  contentClassName,
  popinPosition,
  className = 'mb-20 z-2',
}) => {
  const content = (infoBannerData?.productInformationBanners || [])
    .map((productInformationBanner, index) => {
      const theContextInfoBannerData = productInformationBanner.salesChannel.find(
        (el) => el.context === 'B2C',
      );
      const isDepartureDateIncludedInBannerDates =
        moment(departureDate).isBetween(
          momentFromApiDate(productInformationBanner?.startDate),
          momentFromApiDate(productInformationBanner?.endDate),
          null,
          '[]',
        ) ||
        moment(arrivalDate).isBetween(
          momentFromApiDate(productInformationBanner?.startDate),
          momentFromApiDate(productInformationBanner?.endDate),
          null,
          '[]',
        ) ||
        momentFromApiDate(productInformationBanner?.endDate).isSame(arrivalDate);
      if (
        !theContextInfoBannerData ||
        !isDepartureDateIncludedInBannerDates ||
        !theContextInfoBannerData.tags.includes(currentStep)
      ) {
        return null;
      }
      const { countdown, popin, toaster } = productInformationBanner;
      const infoBannerCountdown = countdown
        ? {
            ...countdown,
            dateTimeEnd: moment(countdown.dateTimeEnd, 'YYYYMMDD HH:mm:ss'),
            days: t('options.countdownLabels.days'),
            hours: t('options.countdownLabels.hours'),
            minutes: t('options.countdownLabels.minutes'),
            seconds: t('options.countdownLabels.seconds'),
          }
        : null;

      return (
        <InfoBanner
          key={`infoBanner_${index}`}
          {...asWidgetProps<ComponentProps<typeof InfoBanner>>({
            ...toaster,
            containerClassName: containerClassName,
            contentClassName: contentClassName,
            countdown: infoBannerCountdown,
            popin: popin,
            popinPosition: popinPosition,
            theme: theme,
          })}
        />
      );
    })
    .filter(Boolean);

  if (!content.length) {
    return null;
  }

  return (
    <div className={classnames('relative isolate flex flex-col gap-10 sm:flex-row', className)}>
      {content}
    </div>
  );
};
